// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tz-2";
export var chatLink = "_tz-0";
export var chatText = "_tz-1";